import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './utils/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import { Toaster } from './components/ui/toaster';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import StorageDashboard from './pages/StorageDashboard';
import AdminDashboard from './pages/AdminDashboard';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import SharedFile from './pages/SharedFile'; // PUBLIC PAGE
import SharedFolder from './pages/SharedFolder'; // PUBLIC PAGE
import DepartmentDrive from './pages/DepartmentDrive';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* ============================================ */}
          {/* 🔥 CRITICAL: Public routes MUST come FIRST */}
          {/* ============================================ */}

          {/* Public Authentication Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* ============================================ */}
          {/* 🆕 PUBLIC SHARED FILE ROUTE - NO AUTH */}
          {/* MUST be before /* catch-all route */}
          {/* Optional :filename parameter for SEO */}
          {/* ============================================ */}
          <Route path="/share/:token/:filename?" element={<SharedFile />} />

          {/* ============================================ */}
          {/* 🆕 PUBLIC SHARED FOLDER ROUTE - NO AUTH */}
          {/* MUST be before /* catch-all route */}
          {/* Optional :filename parameter for SEO */}
          {/* ============================================ */}
          <Route path="/share/folder/:token/:filename?" element={<SharedFolder />} />

          {/* ============================================ */}
          {/* Private Routes (Require Authentication) */}
          {/* ============================================ */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="/stats"
            element={
              <PrivateRoute>
                <StorageDashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            }
          />

          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <Settings />
              </PrivateRoute>
            }
          />

          <Route
            path="/department"
            element={
              <PrivateRoute>
                <DepartmentDrive />
              </PrivateRoute>
            }
          />

          {/* Admin Routes */}
          <Route
            path="/admin"
            element={
              <PrivateRoute>
                <AdminDashboard />
              </PrivateRoute>
            }
          />

          {/* ============================================ */}
          {/* Default Routes */}
          {/* ============================================ */}

          {/* Redirect root to dashboard */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />

          {/* 404 - Redirect to dashboard */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
      <Toaster />
    </AuthProvider>
  );
}

export default App;